<template>
	<div class="solution">
		<div class="banner">
			<img v-if="inwidth>768" :src="banner" alt="">
			<img v-else :src="phone_pic" alt="">
		</div>
		<div class="content">
			<div class="title">Solutions</div>
			<!-- <div class="select"> -->
				<!-- <el-select v-model="myActive" :popper-append-to-body="false" @change="changeData($event)">
					<el-option v-for="item in seleList" :key="item.id" :label="item.class_name" :value="item.id">
					</el-option>
				</el-select> -->
				<!-- <select class="mysele" v-model="myActive" @change="changeData($event)">
					<option v-for="(item,index) in seleList" :value='item.id' :key="index">{{item.class_name}}</option>
				</select> -->
			<!-- </div> -->
			<div class="contlist">
				<div class="mylist animate__animated animate__fadeInUp wow" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)"
				 data-wow-offset="10">
					<div v-if="mobshow">
						<div v-if="(index+1)%3==0" class="bigpic">
							<div class="myimg"><img :src="item.big_pic" alt=""></div>
							<div class="mytit">{{item.title}}</div>
						</div>
						<div v-else class="smallpic">
							<div class="myimg"><img :src="item.pic" alt=""></div>
							<div class="mytit">{{item.title}}</div>
						</div>
					</div>
					<div v-else>
						<div v-if="index==2||index==3" class="bigpic">
							<div class="myimg"><img :src="item.big_pic" alt=""></div>
							<div class="mytit">{{item.title}}</div>
						</div>
						<div v-else class="smallpic">
							<div class="myimg"><img :src="item.pic" alt=""></div>
							<div class="mytit">{{item.title}}</div>
						</div>
					</div>
				</div>
				<div class="tips" v-if="myshow"></div>
				<el-pagination
				  :pager-count='pagercount'
				  background
				  layout="prev, pager, next"
				  :hide-on-single-page="pagehide"
				  :page-size="list_row"
				  :current-page.sync="page"
				  :total="totalCount"
				   @current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		WOW
	} from 'wowjs';
	export default {
		name: "solution",
		data() {
			return {
				mobshow: false,
				myshow:false,
				mystate:false,
				myActive: '',
				inwidth:window.innerWidth,
				banner:'',
				seleList: [],
				dataList: [],
				cate_id: '',
				list_row: 6,
				page: 1,
				totalCount: 1,
				pagehide: true,
				pagercount: 5,
				phone_pic:''
			}
		},
		created() {
			let width = window.innerWidth
			if (width <= 750) {
				this.mobshow = true
			}
			this.getData()
			if(this.$route.query.spage){
				this.page = Number(this.$route.query.spage);
			}else{
				this.page=1
			}
			this.getList(this.page)
		},
		mounted() {
			if (this.mobshow) {
				window.addEventListener('scroll', this.onScroll)
			}
		},
		methods: {
			getData() {
				var that = this;
				let data = {};
				that.$api.projectCate(data).then(res => {
					if (res.status == 1) {
						// that.seleList = res.data.list;
						that.banner = res.data.banner;
						that.phone_pic = res.data.phone_pic;
						// that.cate_id = res.data.list[0].id
						// that.myActive = that.seleList[0].id;
						// that.getList(1)
					} else {
						that.$message({
							message: res.msg,
							type: "warning"
						});
					}
				});
			},
			getList(page) {
				console.log(page)
				var that = this;
				let data = {
					page: page,
					list_row: that.list_row,
					// cate_id: that.cate_id
				};
				if (that.mobshow) {
					let mylist = that.dataList
					that.$api.projectList(data).then(res => {
						if (res.status == 1) {
							mylist = mylist.concat(res.data.list)
							that.dataList = mylist;
							that.totalCount = res.data.pageInfo.totalCount
							that.myshow=false
							that.mystate=true
						} else {
							that.$message({
								message: res.msg,
								type: "warning"
							});
						}
					});
				} else {
					that.$api.projectList(data).then(res => {
						if (res.status == 1) {
							that.dataList = res.data.list;
							that.totalCount = res.data.pageInfo.totalCount
						} else {
							that.$message({
								message: res.msg,
								type: "warning"
							});
						}
					});
				}

			},
			changeData(event) {
				this.myActive = event; //获取ID，即option对应的ID值
				this.cate_id = event;
				this.page = 1
				this.dataList = []
				this.getList(1)
			},
			handleCurrentChange(currentPage) {
				this.$router.push({
					path: '/solutions',
					query: {
						spage:currentPage,
					}
				});
				//  window.location.reload();
				// this.page=currentPage
				this.getList(currentPage)
			},
			goDetail(id) {
				this.$router.push({
					path: '/solutionsDetail',
					query: {
						soluid: id,
					}
				});
			},
			//滚动触底加载
			onScroll() {
				var that = this
				let height = $('.footer').height()
				if (that.mystate) {
					if (that.getScrollHeight() <= that.getWindowHeight() + that.getDocumentTop() + height) {
						that.mystate = false
						if (that.totalCount > that.dataList.length) {
							let page = that.page + 1
							that.getList(page) //请求接口的函数
							that.myshow = false
						} else {
							that.myshow = true
						}
					}
				}
			},
			//文档高度
			getDocumentTop() {
				var scrollTop = 0,
					bodyScrollTop = 0,
					documentScrollTop = 0;
				if (document.body) {
					bodyScrollTop = document.body.scrollTop;
				}
				if (document.documentElement) {
					documentScrollTop = document.documentElement.scrollTop;
				}
				scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
				return scrollTop;
			},
			//可视窗口高度
			getWindowHeight() {
				var windowHeight = 0;
				if (document.compatMode == "CSS1Compat") {
					windowHeight = document.documentElement.clientHeight;
				} else {
					windowHeight = document.body.clientHeight;
				}
				return windowHeight;
			},
			//滚动条滚动高度
			getScrollHeight() {
				var scrollHeight = 0,
					bodyScrollHeight = 0,
					documentScrollHeight = 0;
				if (document.body) {
					bodyScrollHeight = document.body.scrollHeight;
				}
				if (document.documentElement) {
					documentScrollHeight = document.documentElement.scrollHeight;
				}
				scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
				return scrollHeight;
			},
		},
		beforeDestroy() {//清除监听
        	window.removeEventListener('scroll', this.onScroll)
  		},


	}
</script>

<style>
	.solution {
		width: 100%;
		background: #fff;
	}

	.solution .banner {
		width: 100%;
	}

	.solution .banner img {
		width: 100%;
		display: block;
	}

	.solution .content {
		width: 120rem;
		margin: 0 auto;
		padding: 3.0rem 0 5.0rem;
	}

	.solution .title {
		width: 100%;
		padding: 0.6rem 0 1.0rem;
		text-align: center;
		font-size: 3.6rem;
		font-weight: bold;
		color: #4c4c4c;
		letter-spacing: 0.2rem;
	}

	.solution .select {
		width: 23.7rem;
		height: 5.0rem;
	}

	.solution .select .el-select-dropdown__item.selected {
		color: #333333;
	}

	.solution .select .el-input__inner {
		color: #333333;
	}

	.solution .select .mysele {
		width: 23.5rem;
		height: 5.0rem;
		box-sizing: border-box;
		border: 1px solid #e6e6e6;
		font-size: 1.6rem;
		color: #4c4c4c;
		outline: none;
		/* appearance:none;
		-moz-appearance:none;
		-webkit-appearance:none;
		background: url('../../../static/images/solutionsele.png') no-repeat scroll 20rem center transparent; */
		cursor: pointer;
	}

	.solution .el-select .el-input__inner {
		border: 1px solid #e6e6e6;
	}

	.solution .el-select .el-input__inner:focus {
		border: 1px solid #e6e6e6;
	}

	.solution .contlist {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin: auto;
	}

	.solution .mylist {
		margin-right: 1.9rem;
		margin-top: 3.0rem;
		cursor: pointer;
	}

	.solution .mylist:nth-child(3n) {
		margin-right: 0;
	}

	.solution .mylist .bigpic {
		width: 59.0rem;
		margin: auto;
	}

	.solution .mylist .smallpic {
		width: 28.5rem;
		margin: auto;
	}

	.solution .mylist .myimg {
		width: 100%;
		height: 28.6rem;
		overflow: hidden;
	}

	.solution .mylist .myimg img {
		width: 100%;
		display: block;
		transition: all 1s;
		-moz-transition: all 1s;
		-webkit-transition: all 1s;
	}

	.solution .mylist:hover .myimg img {
		transform: scale(1.2);
		-webkit-transform: scale(1.2);
		-moz-transform: scale(1.2);
	}

	.solution .mylist .mytit {
		width: 100%;
		height: 8.0rem;
		background: #fff;
		line-height: 8.0rem;
		border-bottom: 1px solid #cccccc;
		text-align: center;
		font-size: 1.6rem;
		color: #4c4c4c;
		transition: all 1s;
		-moz-transition: all 1s;
		-webkit-transition: all 1s;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.solution .mylist:hover .mytit {
		background: #000000;
		border-bottom: 1px solid #000000;
		color: #fff;
	}

	.solution .contlist .el-pagination {
		margin-top: 5.0rem;
		width: 100%;
		text-align: center;
	}

	.solution .contlist .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #0c131b;
		color: #ffffff;
	}

	.solution .contlist .el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li {
		width: 4rem;
		height: 4rem;
		line-height: 4rem;
		font-size: 1.4rem;
		border-radius: 0;
		color: #868686;
		background-color: #ebebeb;
	}

	.solution .contlist .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #868686;
	}
	.tips{
		width: 100%;
		text-align: center;
		padding: 2rem 0 0;
		font-size: 1.4rem;
		color:#4c4c4c;
	}
	@media(max-width:1200px) {
		.solution .content {
			width: 95%;
		}

		.solution .contlist {
			width: 59.0rem;
		}

		.solution .mylist {
			width: 49%;
			margin-right: 2%;
		}

		.solution .mylist:nth-child(2) {
			margin-right: 0%;
		}

		.solution .mylist:nth-child(3) {
			width: 100%;
		}

		.solution .mylist:nth-child(4) {
			width: 100%;
			margin-right: 0%;
		}
	}

	@media(max-width:768px) {
		.solution .content {
			width: 85%;
		}

		.solution .banner img {
			height: 40.0rem;
			object-fit: cover;
		}
	}

	@media(max-width:750px) {
		.solution .contlist {
			width: 100%;
		}
		.solution .mylist {
			width: 49%;
			margin-right: 2%;
		}
		.solution .mylist:nth-child(3n) {
			width: 100%;
			margin-right: 0%;
		}
		.solution .mylist:nth-child(3n+1) {
			width: 49%;
			margin-right: 2%;
		}
		.solution .mylist:nth-child(3n+2) {
			width: 49%;
			margin-right: 0%;
		}
		.solution .mylist .bigpic {
			width: 100%;
		}
		.solution .mylist .smallpic {
			width: 100%;
		}

		.solution .mylist .myimg {
			width: 100%;
			height: auto;
		}

		.solution .mylist:hover .myimg img {
			transform: scale(1);
			-webkit-transform: scale(1);
			-moz-transform: scale(1);
		}
	}
</style>
